import { RootState } from '../index';
import { IListUserState } from './types';

export function listUserSelector(state: RootState): IListUserState {
  return state.user.listUser;
}
